import store from '@/store';
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  editBtnText: '客户资料',
  editTitle: '客户资料',
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: false,
  menu: true,
  indexLabel: '序号',
  selection: true,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  reserveSelection: true,
  selectable: (row, index) => {
    return row.amount >= 1;
  },
  column: [
    {
      label: '租赁人',
      prop: 'name',
      type: 'input',
      search: true,
      searchPlaceholder: '请输入租赁人',
      display: false,
      searchOrder: 777,
    },
    {
      label: '进件编号',
      prop: 'businessCode',
      display: false,
      search: true,
      searchOrder: 444,
    },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      display: false,
      search: true,
      searchOrder: 666,
    },
    {
      label: '产品类型',
      prop: 'rentTypeList',
      type: 'select',
      display: false,
      search: true,
      searchMultiple: true,
      hide: true,
      showColumn: false,
      dicData: store.getters.porductTypes,
      searchOrder: 888,
    },
    {
      label: '库位',
      prop: 'locationIdList',
      span: 24,
      hide: true,
      search: true,
      display: false,
      type: 'select',
      searchClearable: true,
      filterable: true,
      dicData: [],
      searchOrder: 555,
      props: {
        label: 'storageLocation',
        value: 'id',
      },
    },
    {
      label: '所属代理商',
      prop: 'businessDeptIdList',
      type: 'select',
      filterable: true,
      multiple: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: 'title',
        value: 'id',
      },
    },
    {
      label: '产品类型',
      prop: 'rentType',
      type: 'select',
      display: false,
      search: false,
      searchMultiple: true,
      showColumn: false,
      dicData: store.getters.porductTypes,
    },
    {
      label: '所属代理商',
      prop: 'businessDeptName',
      span: 24,
      display: false,
      search: false,
    },

    {
      label: '数量',
      prop: 'amount',
      span: 24,
      search: false,
      display: false,
    },
    {
      label: '库位',
      prop: 'storageLocationManagementName',
      span: 24,
      search: false,
      display: false,
    },
    {
      label: 'id',
      prop: 'id',
      display: false,
      hide: true,
    },
    // {
    //   label: "入库时间",
    //   prop: "warehouseDeliveryTime",
    //   span: 24,
    //   display: false,
    //   search: false,
    // },
  ],
};
